import { gql } from 'apollo-angular'

export default gql`
  mutation registerUser($data: RegisterInput!) {
    registerUser(data: $data)
  }
`
